import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { DevicesClass } from '@app/core/classes/component/devices.class';
import { RoutingConfig } from '@app/routing/routing.config';
import { Router } from '@angular/router';
import { AccountEventBus, AccountStoryService } from '@app/modules/account-modules/account.story';
import { IAccountUserInfo } from '@app/modules/account-modules/account.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'shared-page-mobile-menu',
  templateUrl: 'page-mobile-menu.component.html',
  styleUrls: [`./page-mobile-menu.component.scss`],
})

export class PageMobileMenuComponent extends DevicesClass implements OnInit {
  /**
   * Base component variables.
   */
  public AccountMenuUser: IAccountUserInfo = null;

  constructor(injector: Injector,
    public cdr: ChangeDetectorRef,
    private router: Router,
    private accountStory: AccountStoryService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.onAccountStoryBus();
  }

  onAccountStoryBus(): void {
    this.accountStory.AccountEventBus$.pipe(untilDestroyed(this)).subscribe(
      emit => this.onAccountStoryListener(emit)
    );
  }

  onAccountStoryListener(emit: AccountEventBus): void {
    if (emit.event === 'onAccountUpdate') {
      this.AccountMenuUser = emit.data ? emit.data : null;
    }

    if (emit.event === 'onAccountLogout' || emit.event === 'onAccountEmpty') {
      this.AccountMenuUser = null;
    }

    this.cdr.markForCheck();
  }

  onSignUp(): void {
    this.router.navigateByUrl(`/${RoutingConfig.Login}/${RoutingConfig.SignUp}`).catch();
  }
}
